import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Typography,
} from "@material-ui/core";
import { getMedicacionHistorialPrevio } from "../../../../actions/empadronamiento/Empadronamiento";
import ChevronDown from "../../UI/ChevronDown";
import { MedicacionHistorialItem } from "../MedicacionHistorialItem";
import { Redirect } from "react-router-dom";
import { useState } from "react";

export const MedicacionAccordionHistorial = (props) => {
  const dispatch = useDispatch();

  const { afiliadoSeleccionado, solicitudesHistorialMed } = useSelector((state) => state.empadronamiento);
  const [redirect, setRedirect] = useState(false);

  useEffect(() => {
    if (afiliadoSeleccionado?.id_afiliado)
      dispatch(getMedicacionHistorialPrevio(afiliadoSeleccionado?.id_afiliado));
  }, [dispatch]);

  return (
    <Accordion TransitionProps={{ unmountOnExit: true }}>
      <AccordionSummary expandIcon={<ChevronDown />}>
        <Typography variant="h6">Historial de Medicación</Typography>
      </AccordionSummary>
      <AccordionDetails>
        {Array.isArray(solicitudesHistorialMed) && solicitudesHistorialMed?.length > 0 ? (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ width: "8%" }}>Estado</TableCell>
                <TableCell style={{ width: "6%" }}>Empadronamiento N°</TableCell>
                <TableCell style={{ width: "6%" }}>Solicitud</TableCell>
                <TableCell style={{ width: "10%" }}>Fecha</TableCell>
                <TableCell style={{ width: "20%" }}>Programa</TableCell>
                <TableCell style={{ width: "12%" }}>Usuario</TableCell>
                <TableCell style={{ width: "5%" }}>Diagnósticos</TableCell>
                <TableCell style={{ width: "5%" }}>Medicamentos</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {solicitudesHistorialMed.map((solicitud, index) => {
                return (
                  <MedicacionHistorialItem
                    key={solicitud?.idSolicitud.toString()}
                    solicitud={solicitud}
                    setRedirect={setRedirect}
                  />
                );
              })}
            </TableBody>
          </Table>
        ) : (
          <Typography style={{ fontSize: "1.1rem", fontStyle: "italic" }}>
            No hay solicitud de medicaciones
          </Typography>
        )}
      </AccordionDetails>
      {redirect && (
        <Redirect
          to={{
            pathname: '/medicacion',
            state: {
              from: '/medicacion/gestion'
            },
          }}
        />
      )}
    </Accordion>
  );
};
